import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EmptyState } from "./EmptyState";

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        title={t("common.notFound")}
        body={t("common.notFoundHint")}
        actions={
          <Link to="/" className="btn btn-primary">
            {t("common.back")}
          </Link>
        }
      />
    </div>
  );
}
